var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49963 6.9016C7.41486 6.9016 8.29254 6.53802 8.93975 5.89092C9.58688 5.24369 9.95043 4.36604 9.95043 3.4508C9.95043 2.53557 9.58685 1.65789 8.93975 1.01069C8.29251 0.363555 7.41486 0 6.49963 0C5.5844 0 4.70672 0.36358 4.05951 1.01069C3.41238 1.65792 3.04883 2.53557 3.04883 3.4508C3.0501 4.36564 3.41406 5.24263 4.06089 5.88956C4.70782 6.5364 5.5848 6.90035 6.49966 6.90163L6.49963 6.9016ZM6.49963 1.02774C7.14205 1.02774 7.75819 1.28292 8.21251 1.73727C8.66676 2.19152 8.92204 2.80763 8.92204 3.45005C8.92204 4.09247 8.66694 4.70861 8.21271 5.16293C7.75846 5.61718 7.14245 5.87246 6.50003 5.87256C5.85761 5.87266 5.24137 5.61756 4.78705 5.16343C4.3327 4.70918 4.07732 4.09318 4.07722 3.45075C4.0782 2.8086 4.33368 2.19317 4.78783 1.73915C5.24197 1.2852 5.85751 1.02992 6.49963 1.02914V1.02774Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02886 14.0214C1.02886 11.0046 3.48308 8.5504 6.49984 8.5504C9.5166 8.5504 11.9708 11.0046 11.9708 14.0214H13C12.9999 12.2975 12.3151 10.6442 11.0961 9.42529C9.87715 8.20635 8.22376 7.52158 6.50001 7.52148C4.77616 7.52148 3.12288 8.20628 1.90393 9.42519C1.29847 10.0274 0.818404 10.7437 0.491633 11.5326C0.164737 12.3215 -0.00232922 13.1675 2.45287e-05 14.0214L1.02886 14.0214Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7da06147ae2902f399e39714880e0187.svg";
export { ForwardRef as ReactComponent };